import React from "react";

import asp_image2 from "../../../Assets/Images/asp-image1.png";
import asp_image3 from "../../../Assets/Images/sp1.png";
import asp_image4 from "../../../Assets/Images/sp2.png";
import asp_image5 from "../../../Assets/Images/sp3.png";
import asp_image6 from "../../../Assets/Images/sp4.png";
import "./photocontainer.css";
export default function PhotoContainer() {
  return (
    <>
      <div className="asp-image-container">
        <div className="image-container asp-item">
          <img src={asp_image2} alt="Sample Image" />
          <div className="overlay">
            <p className="overlay-text">Diverse Sports</p>
          </div>
        </div>
        <div className="image-container asp-item">
          <img src={asp_image3} alt="Sample Image" />
          <div className="overlay">
            <p className="overlay-text">Experienced Coaches</p>
          </div>
        </div>
        <div className="image-container asp-item">
          <img src={asp_image4} alt="Sample Image" />
          <div className="overlay">
            <p className="overlay-text">Skill Development</p>
          </div>
        </div>
        <div className="image-container asp-item">
          <img src={asp_image5} alt="Sample Image" />
          <div className="overlay">
            <p className="overlay-text">Healthy Lifestyle</p>
          </div>
        </div>
        <div className="image-container asp-item">
          <img src={asp_image6} alt="Sample Image" />
          <div className="overlay">
            <p className="overlay-text">Safe Environment</p>
          </div>
        </div>
      </div>
    </>
  );
}
